module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('app-grid-list', _vm._l((_vm.audios), function(audio) {
    return _c('v-flex', {
      key: audio.id,
      attrs: {
        "xs12": "",
        "sm6": "",
        "md4": "",
        "lg2": ""
      }
    }, [_c('audio-teaser', {
      attrs: {
        "audio": audio
      }
    })], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dba95d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SearchResults/SearchResultsMyouseek.vue
// module id = 380
// module chunks = 0